import { randomUUID } from './randomUUID';

try {
  // 根据 IQUIC_PAGE_META 设置埋点通用信息
  const { pagePath, properties } = window.__IQUIC_PAGE_META || {};
  const { $spm, $bizTag } = properties || {};

  let userIdentify = window.localStorage.getItem('ac-h5-userIdentify');

  if (!userIdentify) {
    window.localStorage.setItem('ac-h5-userIdentify', randomUUID());
    userIdentify = window.localStorage.getItem('ac-h5-userIdentify');
  }

  // 初始化 iTracker
  window.iTracker.initiTracker({
    appId: '2102000024800001',
    productId: 'A+Rewards',
    bizType: 'acLotteryH5',
    env: 'prod',
    userId: window.localStorage.getItem('ac-h5-userIdentify'),
    spmConfig: {
      spmAPos: $spm?.spma,
      bizType: 'acLotteryH5',
      pages: {
        index: {
          spmB: $spm?.spmb,
        },
      },
    },
    mdata: {
      iquicPagePath: pagePath,
      spma_tag: $bizTag?.spma || '',
      spmb_tag: $bizTag?.spmb || '',
    },
    // 是否允许使用声明式spm曝光 TODO: 目前尝试发现声明式曝光不生效，暂时仍使用手动埋点上报
    autoExpo: false,
    // 是否允许使用声明式spm点击
    autoClick: false,
    // 设备ID，不填则会生成一个32位UUID
    deviceId: '',
    // 是否一个C位只曝光一次
    expoOnce: false,
    // 是否自动上报漏斗信息
    funnelAuto: false,
    // 是否自动上报用户路径
    userPathAuto: false,
  });
} catch (err) {
  //
}
